// Source: trinity/trinity/Resources/TexturePipeline/Tr2TexturePipelineStepGenerateMips.h
// Marker step: Carbon registers the class with zero attributes; the mip
// generation itself happens where the pipeline is executed.
import { type } from "@carbonenginejs/runtime-utils/schema";
import { CjsModel } from "@carbonenginejs/runtime-utils/model";

/** Tr2TexturePipelineStepGenerateMips (resources) - attribute-free Blue marker class. */
@type.define({ className: "Tr2TexturePipelineStepGenerateMips", family: "resources" })
export class Tr2TexturePipelineStepGenerateMips extends CjsModel
{
}
